var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.333 1.267a4.733 4.733 0 1 0 0 9.466 4.733 4.733 0 0 0 0-9.466M.833 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.333 5.198c.212 0 .384.171.384.383v2.977a.384.384 0 1 1-.767 0V5.581c0-.212.171-.383.383-.383",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.845 3.953a.512.512 0 1 1-1.023 0 .512.512 0 0 1 1.023 0"
})));
export default SvgInfoCircle;